import Axios from "axios";
const Config = require("../../config/default.env").default;

export default {
  namespaced: true,
  state: {
    selectedReport: {},
    showPopup: false,
    isLoadingSubmit: false,
    lastError: null,
  },
  mutations: {
    SET_LAST_ERROR(state, data) {
      state.lastError = data;
    },
    SET_SHOW_POPUP(state, showPopup) {
      state.showPopup = showPopup;
    },
    SET_SELECTED_REPORT(state, report) {
      state.selectedReport = report;
    },
    SET_IS_LOADING_SUBMIT(state, isLoadingSubmit) {
      state.isLoadingSubmit = isLoadingSubmit;
    },
  },
  actions: {
    setSelectedReport({ commit }, data) {
      commit("SET_SELECTED_REPORT", data);
    },
    setShowPopup({ commit }, data) {
      commit("SET_SHOW_POPUP", data);
    },
    submitRequestDownload({ commit, state }, payload) {
      if (state.isLoadingSubmit) {
        return false;
      }
      commit("SET_IS_LOADING_SUBMIT", true);
      return Axios.post(
        `${Config.MS_SOCIOLLA_PUBLIC_API_URL}/insight-factory/users`,
        payload
      )
        .then((response) => {
          commit("SET_LAST_ERROR", null);
          if (response.status !== 200) {
            return false;
          }
          if (response.data && response.data.data) {
            commit("SET_SHOW_POPUP", true);
          }
        })
        .catch((err) => {
          commit("SET_LAST_ERROR", err);
        })
        .finally(() => {
          commit("SET_IS_LOADING_SUBMIT", false);
        });
    },
  },
  getters: {},
};
